module.exports = __webpack_public_path__ + "static/beinclusive-27cdfa3b7a6b49aa47646843df45bc12.png";